
/* @ngInject */
export default function StartProjectController($window, $state, $analytics, ModalService, HPConfig, coachmark, $timeout, PartnerAppsFactory, PermissionsFactory, $location) {
    const vm = this;
    vm.kbygClick = kbygClick;
    vm.applicationClick = applicationClick;
    vm.proPitchClick = proPitchClick;
    vm.mapClick = mapClick;
    vm.isSolicitor = PermissionsFactory.hasPermission('IsSolicitor');
    vm.isAdvertiser = PermissionsFactory.hasPermission('IsAdvertiser');

    autoKBYG();
    // (ajt - 7/26/2016) TODO: Move this code to any additional Dashboard panel with async call.
    if ($window.innerWidth >= HPConfig.screenSizes.screen_md) {
        $timeout(() => {
            coachmark.startCoachmarkTour(true);
        });
    }

    function kbygClick() {
        $analytics.eventTrack('KBYG Open', { category: 'StartProject', label: $state.current.name });
        ModalService.launchLgModal({
            templateUrl: 'app/lead/kbyg/modal/KBYGModalTemplate.html',
            windowClass: 'kbyg-modal',
            controller: 'KBYGModalController',
            controllerAs: 'kbygModal',
        });
    }

    // openKYBG
    function autoKBYG() {
        if ($location.search().openKBYG !== undefined) {
            kbygClick();
        }
    }

    function mapClick() {
        $analytics.eventTrack('Map Open', { category: 'StartProject', label: $state.current.name });
    }

    function applicationClick() {
        $analytics.eventTrack('Application Open', { category: 'StartProject', label: $state.current.name });
    }

    function proPitchClick() {
        $analytics.eventTrack('Proposal Open', { category: 'StartProject', label: $state.current.name });
        $window.open(PartnerAppsFactory.getProPitchLink(), '_blank');
    }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/startProjectController.js